import { renderPanel, type PanelOptions } from './panel';
import { premiumPct } from '../data/premium';
import { pricing, oerePerCall, type EncodingId } from '../data/pricing';
import type { TokenizationResult } from '../tokenize/types';

const ORDER: EncodingId[] = ['p50k_base', 'cl100k_base', 'o200k_base'];

export interface MultiOptions {
  showIds: boolean;
  showCosts: boolean;
}

/** Sync render: caller passes pre-computed Norwegian and (optional) English tokenizations.
 *  Keeping this sync means the rerender orchestrator owns all worker calls and can dedupe. */
export function renderMultipanel(
  root: HTMLElement,
  noResults: Record<EncodingId, TokenizationResult>,
  enResults: Record<EncodingId, TokenizationResult> | null,
  opts: MultiOptions
): void {
  root.classList.add('ow-multipanel');
  root.replaceChildren();
  for (const enc of ORDER) {
    const cell = document.createElement('div');
    cell.className = 'ow-panel-cell';
    root.appendChild(cell);
    const noT = noResults[enc].totalTokens;
    const enT = enResults ? enResults[enc].totalTokens : null;
    const premium = enT != null ? premiumPct(noT, enT) : null;
    const cost = opts.showCosts ? oerePerCall(noT, pricing[enc].usdPerMillion) : null;
    const panelOpts: PanelOptions = { showIds: opts.showIds, premium, oerePerCall: cost };
    renderPanel(cell, noResults[enc], panelOpts);
  }
}
